import { socketMessage } from "WEBSOCKET/constants";
import * as log from "loglevel";
import { ACTIONS } from "UTILS/Constants";

log.setLevel("info");

export const handleMessage = (data, store) => {
  let timestamp = new Date();
  switch (data.action) {
    case socketMessage.subCategories.CHAT._SEND_MESSAGE:
      store.dispatch({
        type: ACTIONS.CHAT.ADD_MESSAGE,
        messageDetails: {
          sender: data.sender,
          message: data.message,
          participantId: data.participantId,
          timestamp: timestamp
        }
      });
      store.dispatch({
        type: ACTIONS.CHAT.DISPLAY_MESSAGE,
        messageDisplay: true
      });
      store.dispatch({
        type: ACTIONS.CHAT.MESSAGE_ARRIVED,
        value: true
      });
      store.dispatch({
        type: ACTIONS.CHAT.SET_MESSAGES_READ,
        value: false
      });
      break;
  }
};
